export const SET_AUTH_USER = "SET_AUTH_USER";
export const SET_USER_IN_ACTIVE = "SET_USER_IN_ACTIVE";
